import { render } from "./StatsCard.vue?vue&type=template&id=5bd7dfc6&scoped=true"
import script from "./StatsCard.vue?vue&type=script&lang=js"
export * from "./StatsCard.vue?vue&type=script&lang=js"

import "./StatsCard.vue?vue&type=style&index=0&id=5bd7dfc6&scoped=true&lang=scss"

import exportComponent from "/home/lexmodo/Vue/FraudLabs/fraudlabs_vue/fraudlabs_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd7dfc6"]])

export default __exports__